import {
  convert,
  newDate,
  extractKeys
} from '@/sui/data/flatten/tools'

import {
  episodAge,
  episodDays,
  findSurveillance,
  initializeSurveillance,
  origin,
  addBacteremia,
  unitType
} from '@/sui/data/flatten/common'

function initializeSheet (p, s, v) {
  const result = {
    type: 'bactADI',
    surv_id: p.sv
  }

  initializeSurveillance(result, s)

  result.sheet_id = p.id
  result.v = p.v
  result.st = p.st
  result.unit_type = unitType(s.year, p.f.unitType)
  result.uf = p.f.uf
  result.sheet_number = p.f.sheetNumber
  result.birthdate = newDate(p.f.birthdate)
  result.age_years = episodAge(p.f, p.f.bacteremia)
  result.age_days = episodDays(p.f, p.f.bacteremia)
  result.sex = p.f.sex
  result.entry = newDate(p.f.entry)
  result.immuno = p.f.immuno
  if (v >= 2) {
    result.cancer = p.f.cancer
  }

  if (v === 1) {
    result.origin = origin(p.f.origin)
  } else {
    const neo = p.f.birthWeight != null
    result.ad_ped_origin = neo ? null : p.f.origin
    if (v >= 4) {
      result.ad_ped_bmi = p.f.bmi
    }
    result.neo_origin = neo ? p.f.origin : null
  }

  result.mix_managment = p.f.mixManagment
  result.neo_birth_weight = p.f.birthWeight
  result.neo_gestational_age = p.f.gestationalAge

  if (v === 1) {
    result.future = p.f.future
  } else {
    result.dead = p.f.dead
  }
  result.death = newDate(p.f.death)

  return result
}

const reducer = (v) => (result, p) => {
  const s = findSurveillance(result, p)
  if (s != null && result.p.onlyClosed && s.status !== 'closed') {
    --result.r.length
    return result
  }

  const sheet = initializeSheet(p, s, v)
  if (result.keys == null) {
    result.keys = Object.keys(sheet)
  }

  addBacteremia(`bact1`, sheet, p.f, p.f.bacteremia, v)

  extractKeys(result, sheet, ['bact'])

  result.r[result.i++] = sheet
  return result
}

function run (v) {
  return (params) => convert(params, reducer(v), ['bact'])
}

export default {
  // 2019 sheets are migrated to 2020
  '2019': run(2),
  '2020': run(2),
  '2021': run(3),
  '2022': run(3),
  '2023': run(4),
  '2024': run(5),
  '2025': run(6),
  '2026': run(6)
}
